import React from "react";
import classNames from "classnames";

import { XIcon } from "@fourkites/elemental-atoms";

import "./ModalHeader.scss";

import ModalHeaderProps from "./ModalHeader.types";

const ModalHeader = ({ title, subtitle, size, onClose }: ModalHeaderProps) => {
  const modalHeaderClass = classNames(
    "elemental-modal-header",
    `modal-${size}`
  );
  const modalHeaderTitleContainerClass = classNames(
    "elemental-modal-header-title-container",
    `modal-${size}`
  );
  const modalHeaderTitleClass = classNames(
    "elemental-modal-header-title",
    `modal-${size}`
  );
  const modalHeaderSubtitleClass = classNames(
    "elemental-modal-header-subtitle",
    `modal-${size}`
  );
  const modalHeaderIconContainerClass = classNames(
    "elemental-modal-close-icon-container",
    `modal-${size}`
  );
  const modalHeaderIconClass = classNames(
    "elemental-modal-close-icon",
    `modal-${size}`
  );

  return (
    <div className={modalHeaderClass} data-testid="elemental-modal-header">
      <span className={modalHeaderTitleContainerClass}>
        <h5 className={modalHeaderTitleClass}>{title}</h5>
        {subtitle && (
          <span className={modalHeaderSubtitleClass}>{subtitle}</span>
        )}
      </span>

      <button className={modalHeaderIconContainerClass} onClick={onClose}>
        <XIcon iconClass={modalHeaderIconClass} />
      </button>
    </div>
  );
};

export default ModalHeader;
